<template>
    <div    class="w-full flex justify-center items-center">
      <slide-over-panel v-model:show="showDataLogsModeSlideover">
        <template #title>
          Data Logs
        </template>
        <template #title-content>
          Here's a list of all DataLogs events for this point of monitoring.
        </template>
        <template #content>
          <meter-view-data-logs-mode v-if="showDataLogsModeSlideover"
                                   :data-logs="dataLogs"
                                   @show:data-logs="dataLogsMode($event)"
          >

          </meter-view-data-logs-mode>
        </template>
      </slide-over-panel>

        <div    class="w-full flex flex-col bg-white px-4 py-5 border-b border-gray-200 sm:px-6 justify-center">
            <div    class="flex flex-col items-center w-full">
                <!-- Header row with Meter Name & Diag info -->
                <div    class="grid grid-cols-1 md:flex md:items-end md:justify-between md:mb-2 w-full lg:w-1/2 2xl:w-1/3">


                    <div        class="">
                        <a      v-if="permissions.can('edit_meter')"
                                :href="company.buildCompanyRoute(`meters/${id}/edit`)"
                                class="plain-link text-2xl text-left font-semibold text-gray-900">
                            {{ name }}
                        </a>
                        <span   v-else
                                class="plain-link cursor-not-allowed text-2xl text-left font-semibold text-gray-900">
                            {{ name }}
                        </span>

                        <!-- Room Name if it exists -->
                        <div    v-if="this.roomName"
                                class="pt-2">
<!--                            <span><b>View Room Name</b>-->
                            <span class="rounded-full w-full my-8 px-8 py-1 text-sm font-bold bg-blue-100 text-blue-800">
                              {{ roomName }}</span>
<!--                            </span>-->
                        </div>
                    </div>

                    <!-- Fill in some of the Diagnostic Components & Favorite Meter Here -->
                    <div    v-if="loading">
                        <div class="flex ">
                            <span :class="iconLoading"></span>
                        </div>
                    </div>
                    <div    v-else
                            class="flex flex-row shrink items-center justify-start w-1/6  lg:ml-2">
                        <div    v-if="permissions.isSonicu() && gateway900"
                                class="shrink mr-2">
                            <undecorated-link  :href="company.buildCompanyRoute(`meters/${gateway900.ID}`)">
                                <span   class="lnr icon-antenna text-gray-900"></span>
                            </undecorated-link>
                        </div>
                        <div class="shrink mr-1">
                            <battery-percent-icon v-if="batteryPercent"
                                                  v-bind="batteryPercent"></battery-percent-icon>
                        </div>
                        <div    class="shrink mx-1">
                            <signal-strength-icon v-if="signalStrength"
                                                  v-bind="signalStrength"></signal-strength-icon>
                        </div>
                        <div    class="shrink mx-1">
                            <signal-noise-ratio-icon v-if="signalNoiseRatio"
                                                  v-bind="signalNoiseRatio"></signal-noise-ratio-icon>
                        </div>
                        <div    v-if="showMapMarker"
                                class="mx-1">
                            <span   :class="iconMapPin"
                                    class="cursor-pointer"
                                    @click="showGpsData()"
                                    @click.middle="showGpsData(true)"
                            ></span>
                        </div>
                        <div    v-if="dataLogs != null && dataLogs.length > 0"
                                class="mx-1">
                            <span   :class="iconDataLogs"
                                    class="cursor-pointer"
                                    @click="showDataLogsModeSlideover = !showDataLogsModeSlideover"
                                    @click.middle="showDataLogsModeSlideover = !showDataLogsModeSlideover"
                            ></span>
                        </div>
                        <div    class="mx-1">
                            <meter-favorite
                                    class=""
                                    :favorite="isFavorite"
                                    :meter-id="id"
                            ></meter-favorite>
                        </div>
                        <div    v-if="permissions.isSonicu()"
                                class="ml-1"
                                :data-tippy-content="viewGapsTooltip">
                            <toggle     name="gaps_toggle"
                                        v-model:value="viewGaps"></toggle>
                        </div>
                    </div>
                </div>

                <!-- Date-picker / time range row -->
                <div    class="flex flex-col text-base w-full md:w-2/3 lg:w-1/2 2xl:w-1/3">
                    <!-- This example requires Tailwind CSS v2.0+ -->
                    <span class="w-full relative z-0 inline-flex grow shadow-sm rounded-md my-2">
                        <button     type="button"
                                    @click="updateStart('hour')"
                                    class="relative inline-flex grow justify-center cursor-pointer items-center px-4 py-2 rounded-l-md border border-gray-300 text-sm font-medium focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                                    :class="[intervalIsHour ? 'bg-blue-500 text-white hover:bg-blue-400 ' : 'bg-white text-gray-700 hover:bg-gray-200']">
                            Hour
                        </button>
                        <button     type="button"
                                    @click="updateStart('day')"
                                    class="-ml-px relative inline-flex grow justify-center cursor-pointer items-center px-4 py-2 border border-gray-300 text-sm font-medium focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                                    :class="[intervalIsDay ? 'bg-blue-500 text-white hover:bg-blue-400 ' : 'bg-white text-gray-700 hover:bg-gray-200']">
                            Day
                        </button>
                        <button     type="button"
                                    @click="updateStart('week')"
                                    class="-ml-px relative inline-flex grow cursor-pointer justify-center items-center px-4 py-2 border border-gray-300 text-sm font-medium focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                                    :class="[intervalIsWeek ? 'bg-blue-500 text-white hover:bg-blue-400 ' : 'bg-white text-gray-700 hover:bg-gray-200 ']">
                            Week
                        </button>
                        <button     type="button"
                                    @click="updateStart('month')"
                                    class="-ml-px relative inline-flex grow justify-center cursor-pointer items-center px-4 py-2 rounded-r-md border border-gray-300 text-sm font-medium focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                                    :class="[intervalIsMonth ? 'bg-blue-500 text-white hover:bg-blue-400 ' : 'bg-white text-gray-700 hover:bg-gray-200']">
                            Month
                        </button>
                    </span>

                    <div class="flex flex-row relative justify-between items-end mt-2 mb-6 gap-2">

                        <span v-if="startIsAtMinimum" class="absolute -bottom-1 mt-4 left-0 text-xs translate-y-full text-yellow-700 ml-1">Currently at earliest date</span>
                        <span v-if="startIsBeforeMinimum" class="absolute -bottom-1 mt-4 left-0 text-xs translate-y-full text-red-900 ml-1">Currently before earliest date</span>

                        <div class="flex w-full">

                            <div class="flex flex-col w-full">
                                <label for="startDate" class="text-sm text-gray-800 ml-1">Start</label>
                                <date-time-picker id="startDate"
                                                  v-model="startDate"
                                                  :min-date="earliestDate"
                                                  :side-by-side="true"
                                                  :timezone="timezone"
                                                  :format="format">
                                </date-time-picker>
                            </div>

                            <div class="flex flex-col w-full">
                                <label for="endDate" class="text-sm text-gray-800 ml-1">End</label>
                                <date-time-picker id="endDate"
                                                  v-model="endDate"
                                                  :min-date="startDate"
                                                  :side-by-side="true"
                                                  :timezone="timezone"
                                                  :format="format">
                                </date-time-picker>
                            </div>

                        </div>

                        <button v-if="dateRangeChanged" @click="updateChart" class="bg-transparent hover:bg-blue-50 text-blue-900 w-1/3 rounded-md text-sm leading-normal px-3 py-2 border border-blue-500 hover:border-blue-400 relative">
                            <span v-if="dateRangeChanged" class="absolute w-4 h-4 bg-blue-500 top-0 right-0 translate-x-1/2 -translate-y-1/2 rounded-full">
                                <span class="bg-blue-500 w-4 h-4 animate-ping inline-flex rounded-full"></span>
                            </span>
                            Apply <span class="sm:inline-block hidden">Date Range</span>
                        </button>

                    </div>

                    <!-- Show point pair or just this point. -->
                    <span   v-if="(hasFeatureMultiHT && showPairedPointButton) || (hasFeatureMultiAll && showSeriesButton)"
                            class="w-full relative z-0 inline-flex grow shadow-sm rounded-md my-2">
                        <button     v-if="showPairedPointButton || showSeriesButton"
                                    type="button"
                                    @click="setSeriesDisplayMethod('thisPoint')"
                                    class="relative inline-flex grow justify-center cursor-pointer items-center px-4 py-2 rounded-l-md border border-gray-300 text-sm font-medium focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 w-full"
                                    :class="[seriesDisplayMethod === 'thisPoint' ? 'bg-blue-500 text-white hover:bg-blue-400 ' : 'bg-white text-gray-700 hover:bg-gray-200']">
                            Only this Point
                        </button>
                        <button     v-if="hasFeatureMultiHT && showPairedPointButton"
                                    type="button"
                                    @click="setSeriesDisplayMethod('pairedPoint')"
                                    class="-ml-px relative inline-flex grow justify-center cursor-pointer items-center px-4 py-2 border border-gray-300 text-sm font-medium focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 w-full"
                                    :class="[seriesDisplayMethod === 'pairedPoint' ? 'bg-blue-500 text-white hover:bg-blue-400 ' : 'bg-white text-gray-700 hover:bg-gray-200',
                                             hasFeatureMultiAll && showSeriesButton ? 'rounded-r-none' : 'rounded-r-md'
                                    ]">
                            Show Additional Linked Point
                        </button>
                        <button     v-if="hasFeatureMultiAll && showSeriesButton"
                                    type="button"
                                    @click="setSeriesDisplayMethod('seriesList')"
                                    class="-ml-px relative inline-flex grow justify-center cursor-pointer items-center px-4 py-2 rounded-r-md border border-gray-300 text-sm font-medium focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 w-full"
                                    :class="[seriesDisplayMethod === 'seriesList' ? 'bg-blue-500 text-white hover:bg-blue-400 ' : 'bg-white text-gray-700 hover:bg-gray-200']">
                            Show Series
                        </button>
                    </span>
                </div>
            </div>

            <!-- Meter Graph -->
            <div    class="">
                <meter-graph-full :id="id"
                                  :name="this.name"
                                  :start-date="startDate"
                                  :end-date="endDate"
                                  :use-short-gaps="viewGaps"
                                  :file-name="graphFileName"
                                  v-model:timezone="timezone"
                                  :filter-data-ready="!loading && firstLoad"
                                  :pair-points="pairMeters"
                                  :pair-point-options="pairMeterOptions"
                                  :show-paired-point="showPairedPoint"
                                  :paired-points="pairedMeters"
                                  :point-ids="pointIds"
                                  :validation-readings="validationReadings"
                                  v-model:show-series-modal="showSeriesModal"
                                  :username="username"
                                  @hasSeriesForModal="updateCanShowModal"
                                  ref="meterGraphFull"
                ></meter-graph-full>
            </div>
        </div>
    </div>

</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from "@/mixins/IconNamesMixin"
import {am4Settings} from "@/mixins/am4charts/am4Settings";

import axios from "axios";
import tippy from 'tippy.js';
import _ from 'lodash'

import MeterGraphFull from "@/components/MeterGraphFull";
import loading from "@/components/elements/loading"
import Toggle from "@/components/elements/toggle"
import SignalStrengthIcon from "@/components/SignalStrengthIcon";
import BatteryPercentIcon from "@/components/BatteryPercentIcon";
import MeterFavorite from "@/components/meterFavorite";
import DateTimePicker from "@/components/Reports/DateTimePicker";
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link";
import SignalNoiseRatioIcon from "@/components/SignalNoiseRatioIcon";
import {Features} from "@/mixins/AuthorizationHelpers/Features";
import MeterViewDataLogsMode from "@/components/MeterViewDataLogsMode.vue";
import ZoneUsersNotificationMethods from "@/components/zoneUsersNotificationMethods.vue";
import SlideOverPanel from "@/components/elements/SlideOverPanel.vue";
import MeterViewDataLogs from "@/components/MeterViewDataLogsMode.vue";
import SonicuButton from "@/components/elements/buttons/SonicuButton.vue";

const LOAD_DATA_DELAY = 0
const DISPLAY_THIS_POINT = 'thisPoint'
const DISPLAY_PAIRED_POINT = 'pairedPoint'
const DISPLAY_SERIES_LIST = 'seriesList'

export default {
    name: "MeterView",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {
      SonicuButton,
      MeterViewDataLogs,
      SlideOverPanel, ZoneUsersNotificationMethods,
      MeterViewDataLogsMode,
      SignalNoiseRatioIcon,
        UndecoratedLink,
        MeterFavorite, BatteryPercentIcon, SignalStrengthIcon, MeterGraphFull, loading, Toggle, DateTimePicker },
    props: {
        id: Number,
        name: String,
        deviceType: String,
        start: {
            type: String,
            default: null,
        },
        end: {
            type: String,
            default: null,
        },
        dataLogs: {
            type: Array,
            default: null,
        },
        validationReadings: {
            type: Array,
            default: null,
        },
        username: String,
    },
    data() {
        return {
            _loadFunction: null,
            tippyInstance: null,
            loading: false,
            gateway900: null,
            signalStrength: null,
            batteryPercent: null,
            signalNoiseRatio: null,
            isFavorite: false,
            earliestDate: null,
            minDate: null,
            startDate: null,
            endDate: null,
            format: 'MM/DD/YYYY HH:mm',
            timezone: 'UTC',
            roomName: null,
            firstLoad: false,
            dateRangeChanged: false,

            viewGaps: false,
            viewGapsTooltip: 'Show gaps on graph when there has not been data for 30 minutes.',
            pairMeters: {},
            pairMeterOptions: {},
            pairPointId: {},
            showSeriesModal: false,
            showPairedPoint: false,
            showDataLogsModeSlideover: false,
            pairedMeters: [],
            pointIds: [],
            // Loading Status Data

            // UI control flags to determine if the Add Paired Point or the Show Series buttons should be visible.
            showPairedPointButton: false,
            showSeriesButton: false,
            seriesDisplayMethod: DISPLAY_THIS_POINT,

            gpsRoute: null,
        }
    },
    created() {
        console.time(`MeterView@lifeCycle`)
        this._loadFunction = _.debounce(() => {
            this.loading = true
            console.timeLog(`MeterView@lifeCycle`, 'Load Function Started')

            console.time(`MeterView@AxiosViewMeter`)
            axios.get(this.company.buildCompanyApiInternalRoute('view-meter') + '/' + this.id
                ).then(response => {
                    console.timeLog(`MeterView@AxiosViewMeter`, 'Responce first received')
                    let data = response.data
                    this.gateway900 = data.gateway900
                    this.signalStrength = data.signalStrength
                    this.batteryPercent = data.batteryPercent
                    this.signalNoiseRatio = data.signalNoiseRatio
                    this.gpsRoute = data.gpsRoute
                    this.isFavorite = data.isFavorite
                    this.earliestDate = new Date(new Date(data.minDate).setHours(0, 0, 0, 0))
                    this.pairMeterOptions = data.pairMeterOptions
                    this.pairMeters = data.pairMetersList
                    this.pairedMeters = data.pairLinkedMeters
                    this.pointIds = data.pointIds
                    this.roomName = _.isNil(data.roomName) ? null : data.roomName

                    // If the Pair Meter is defined then show the paired point button
                    if (!_.isNil(this.pairMeters) && !_.isEmpty(this.pairMeters)) {
                        this.showPairedPointButton = true
                    }

                    try {
                        this.minDate = new Date(data.minDate)
                    }
                    catch (e) {
                        console.warn("MeterView - Error Creating minDate from: " + data.minDate)
                        // If there is an error setting the minDate force the min date to be 1 day ago.
                        // The logic is hoping these are mostly new meters.  Maybe we just make it a long time ago.
                        let now = new Date(Date.now())
                        now.setDate(now.getDate() - 1)
                        this.minDate = now
                    }

                    this.minDate.setSeconds(0)
                    this.minDate.setMilliseconds(0)

                    this.timezone = data.timezone
                    this.loading = false
                    this.firstLoad = true

                    console.timeEnd(`MeterView@AxiosViewMeter`)
                    console.timeLog(`MeterView@lifeCycle`, `Axios View Meter Response Completed`)

                    this.verifyUI()
                }
            )
        }, LOAD_DATA_DELAY)
        this.startDate = new Date()
        this.endDate = new Date()
        let intervalEstablished = false
        if (! _.isNil(this.start) && this.start !== '') {
            this.startDate = new Date(this.start)
            intervalEstablished = true
        }
        if (! _.isNil(this.end) && this.end !== '') {
            this.endDate = new Date(this.end)
            intervalEstablished = true
        }

        if (!intervalEstablished) {
            this.updateStart(this.deviceType === 'sound' ? 'hour' : 'day')
        }
    },
    mounted() {
        this.loadData()
        this.showPairedPoint = false
        this.tippyInstance = tippy('[data-tippy-content]');
    },
    methods: {
        loadData() {
            this._loadFunction()
        },
        updateChart() {
            console.log(this.earliestDate)
          if (this.$refs.meterGraphFull) {
            this.$refs.meterGraphFull.updateChart();
            this.dateRangeChanged = false;
          }
        },
        updateStart(interval) {
            let timesUpdated = false
            let startDate = new Date(Date.now())
            startDate.setSeconds(0, 0)
            let endDate = new Date(Date.now())
            endDate.setSeconds(0, 0)

            if (interval === 'hour') {
                let newHours = startDate.getHours() - 1
                timesUpdated = true
                startDate.setHours(newHours)
            }
            else if (interval === 'day') {
                let newDate = startDate.getDate() - 1
                timesUpdated = true
                startDate.setDate(newDate)
            }
            else if (interval === 'week') {
                let newDate = startDate.getDate() - 7
                timesUpdated = true
                startDate.setDate(newDate)
            }
            else if (interval === 'month') {
                let newMonth = startDate.getMonth() - 1
                timesUpdated = true
                startDate.setMonth(newMonth)
            }

            if (timesUpdated) {
                if (!_.isNil(this.minDate)) {
                    this.startDate = new Date(Math.max(startDate.getTime(), this.minDate.getTime()))
                }
                else {
                    this.startDate = startDate
                }
                this.endDate = endDate
            }

            this.updateChart()
        },
        setThisPointMethod() {
            this.seriesDisplayMethod = DISPLAY_THIS_POINT
            this.showSeriesModal = false
            this.showPairedPoint = false
        },
        setPairedPointMethod() {
            if (!this.showPairedPointButton) {
                // Bail Early because we cannot use paired points
                console.log(`Display Method FAILED - Paired Point`)
                return
            }

            this.seriesDisplayMethod = DISPLAY_PAIRED_POINT
            this.showSeriesModal = false
            this.showPairedPoint = true
            this.fathomGoalTrack()
        },
        setSeriesListMethod() {
            if (!this.showSeriesButton) {
                // Bail Early because we cannot use a series List
                console.log(`Display Method FAILED - Series List`)
                return
            }

            this.seriesDisplayMethod = DISPLAY_SERIES_LIST
            this.showSeriesModal = true
            this.showPairedPoint = false
        },
        setSeriesDisplayMethod(display) {
            switch (display) {
                case DISPLAY_PAIRED_POINT:
                    this.setPairedPointMethod()
                    break

                case DISPLAY_SERIES_LIST:
                    this.setSeriesListMethod()
                    break

                default:
                    this.setThisPointMethod()
                    break
            }
        },
        verifyUI() {
            // This is to ensure that the current UI flags all follow logical sense based on the various state variables.
            if (!this.showSeriesButton && this.seriesDisplayMethod === DISPLAY_SERIES_LIST) {
                console.log(`Unable to show Series List, Reverting To Display Method - This Point`)
                this.setThisPointMethod()
            }

            if (!this.showPairedPointButton && this.seriesDisplayMethod === DISPLAY_PAIRED_POINT) {
                this.setThisPointMethod()
            }
        },
        fathomGoalTrack() {
            if (window.fathomLoaded && am4Settings.FATHOM_GOALS.showPairedPoint.length > 0) {
                window.fathom.trackGoal(am4Settings.FATHOM_GOALS.showPairedPoint, 0);
            }
        },
        selectSeriesToShow() {
            this.showSeriesModal = ! this.showSeriesModal
        },
        updateCanShowModal(hasSeries) {
            this.showSeriesButton = hasSeries
            this.verifyUI()
        },
        showGpsData(newTab = false) {
            if (newTab) {
                window.open(`${this.gpsRoute}`, '_blank')
            }
            else {
                window.location = this.gpsRoute
            }
        },
        dataLogsMode(thisDataLogEvent){
          console.log("This is my event: ", thisDataLogEvent)
          this.startDate = new Date(thisDataLogEvent.created_at);
          this.$nextTick(() => {
            // We have to wait for the next tick, or we tend to run into issues where the `minDate` value doesn't
            // get processed quickly enough, which means the visual DatePicker doesn't get updated.
            this.endDate = new Date(thisDataLogEvent.completed_at);
          })
          this.showDataLogsModeSlideover = false;
        },
    },
    watch: {
        startDate() {
            if (this.dateDiff < 35 && this.dateDiff >= 0 && this.dateRangeChanged === false) {
                this.updateChart()
            } else {
                this.dateRangeChanged = true;
            }
        },
        endDate() {
            if (this.dateDiff < 35 && this.dateDiff >= 0 && this.dateRangeChanged === false) {
                this.updateChart()
            } else {
                this.dateRangeChanged = true;
            }
        }
    },
    computed: {
        showBatteryPercent() {
            return ! _.isNil(this.batteryPercent)
        },
        showSignalStrength() {
            return ! _.isNil(this.signalStrength)
        },
        showSignalNoiseRatio() {
            return ! _.isNil(this.signalNoiseRatio)
        },
        showMapMarker() {
            return ! _.isNil(this.gpsRoute)
        },
        intervalIsHour() {
            let tmp = new Date(this.startDate.getTime())
            tmp.setHours(this.startDate.getHours() + 1)
            return tmp.getTime() === this.endDate.getTime()
        },
        intervalIsDay() {
            let tmp = new Date(this.startDate.getTime())
            tmp.setDate(this.startDate.getDate() + 1)
            return tmp.getTime() === this.endDate.getTime()
        },
        intervalIsWeek() {
            let tmp = new Date(this.startDate.getTime())
            tmp.setDate(this.startDate.getDate() + 7)
            return tmp.getTime() === this.endDate.getTime()
        },
        intervalIsMonth() {
            let tmp = new Date(this.startDate.getTime())
            tmp.setMonth(this.startDate.getMonth() + 1)
            return tmp.getTime() === this.endDate.getTime()
        },
        graphFileName() {
            return `${this.name} (${this.formatStart})-(${this.formatEnd})`
        },
        formatStart() {
            return `${this.startDate.getMonth() + 1}_${this.startDate.getDate()}_${this.startDate.getFullYear()} ` +
                    `${this.startDate.getHours()} ${this.startDate.getMinutes()} ${this.startDate.getSeconds()}`
        },
        formatEnd() {
            return `${this.endDate.getMonth() + 1}_${this.endDate.getDate()}_${this.endDate.getFullYear()} ` +
                    `${this.endDate.getHours()} ${this.endDate.getMinutes()} ${this.endDate.getSeconds()}`
        },
        startIsAtMinimum() {
            if (_.isNil(this.minDate)) {
                return false
            }
            return Math.round(this.startDate.getTime() / 1000 / 60) === Math.round(this.minDate.getTime() / 1000 / 60)
        },
        startIsBeforeMinimum() {
            if (_.isNil(this.minDate)) {
                return false
            }
            return Math.round(this.startDate.getTime() / 1000 / 60) < Math.round(this.minDate.getTime() / 1000 / 60)
        },
        hasFeatureMultiHT() {
            return this.featureLevel.hasFeature(Features.POINT_VIEW_MULTI_HT)
                    || this.featureLevel.hasFeature(Features.POINT_VIEW_MULTI_ALL)
                    || this.useSonicuOverrideOnQa
        },
        hasFeatureMultiAll() {
            return this.featureLevel.hasFeature(Features.POINT_VIEW_MULTI_ALL) || this.useSonicuOverrideOnQa
        },
        useSonicuOverrideOnQa() {
            // If the env is Qa and the user is a sonicu user then we want to override the feature level
            return (this.environment.isQa())
                && (this.permissions.isSonicu() || this.permissions.isSonicuViewOnly())
        },
        dateDiff() {
            const diffInMs = new Date(this.endDate) - new Date(this.startDate);
            return diffInMs / (1000 * 60 * 60 * 24);
        }
    },
    beforeUnmount() {
        this._loadFunction = null
    }
}

</script>

<style>
#startDate, #endDate {
  border-color: rgb(212 212 216 / var(--tw-border-opacity));
  border-radius: 0.375rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: rgb(63 63 70 / var(--tw-text-opacity));
  font-size: 0.875rem;
  width: 100%;
}

#startDate {
  border-right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

#endDate {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
